import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ButtonTitle from "../../components/ButtonTitle";
import Activiti from "../../components/client/Activiti";
import SocialResponsibility from "../../components/client/SocialResponsibility";
import apiCustom from "../../utils/ApiCustom";
import ArticleCard from "../../components/client/ArticleCard";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { HomeIcon } from "@heroicons/react/24/outline";
const DetailPost = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [commentLoading, setCommentLoading] = useState(false);
  const posts = useSelector((state) => state.posts.posts);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const post = posts
      ?.filter((post) => post.status === "published")
      ?.find((post) => post.slug === slug);
    window.scrollTo(0, 0);
    const fetchArticle = async () => {
      try {
        if (!post) {
          setError("Post not found");
          setLoading(false);
          return;
        }
        const response = await apiCustom.get(`posts-public/${post.id}`);
        setArticle(response.data.data);
        setComments(response.data.data.comments || []);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchArticle();
  }, [slug, posts]);

  if (loading) {
    return <div className="container mx-auto px-4">Loading...</div>;
  }

  if (error) {
    return <div className="container mx-auto px-4">Error: {error}</div>;
  }

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    setCommentLoading(true);

    try {
      const response = await apiCustom.post(
        "comment-create",
        {
          content: newComment,
          postId: article.id,
          userId: Number(localStorage.getItem("userId")),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast(response.data.message || "Gửi bình luận thành công", {
        type: "success",
      });

      const createdComment = response.data.data;

      // setComments([...comments, createdComment]);
      setNewComment("");
    } catch (err) {
      console.error("Failed to submit comment:", err);
    } finally {
      setCommentLoading(false);
    }
  };

  console.log(article);

  return (
    <div className="container mx-auto px-4">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 flex-wrap">
          <li className="inline-flex items-center">
            <Link to="/" className="inline-flex items-center hover:text-blue-600 font-medium">
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium">{article?.category?.name || "Tin tức và sự kiện"}</span>
            </div>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium truncate max-w-[200px]">{article?.title}</span>
            </div>
          </li>
        </ol>
      </nav>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <div className="lg:col-span-3 overflow-auto">
          <h1 className="text-[24px] font-bold mb-4">{article?.title}</h1>
          <div className="text-gray-600 mb-6">
            {new Date(article?.createdAt).toLocaleDateString("vi-VN")}
          </div>
          <div className="flow-root">
            <div className="sun-editor-editable">
              <div
                className="prose max-w-none"
                dangerouslySetInnerHTML={{ __html: article?.content }}
              />
            </div>
          </div>
          <div
            className={`mt-8 ${article?.category?.isComment ? "" : "hidden"}`}
          >
            <h2 className="text-2xl font-semibold mb-4">Bình luận</h2>
            {comments.length > 0 ? (
              <div className="space-y-4">
                {comments.map((comment) => (
                  <div key={comment.id} className="bg-gray-100 p-4 rounded-lg">
                    <div className="flex items-center mb-2">
                      <span className="font-medium text-gray-800">
                        {comment.user?.userFullName || "Ẩn danh"}
                      </span>
                      <span className="text-gray-500 text-sm ml-2">
                        {new Date(comment.createdAt).toLocaleString("vi-VN")}
                      </span>
                    </div>
                    <p className="text-gray-700">{comment.content}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500">Chưa có bình luận nào.</p>
            )}

            {/* Comment Submission Form */}
            <form
              onSubmit={handleCommentSubmit}
              className="mt-6 bg-gbase-100 pb-4 rounded-lg"
            >
              <textarea
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                placeholder="Nhập bình luận của bạn..."
                className="w-full p-2 border rounded-md mb-4 min-h-[100px]"
                required
              />
              <button
                type="submit"
                disabled={commentLoading || !localStorage.getItem("userId")}
                className={`
                  px-4 py-2 rounded-md text-white font-semibold
                  ${
                    commentLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                  }
                `}
              >
                {commentLoading
                  ? "Đang gửi..."
                  : !localStorage.getItem("userId")
                  ? "Đăng nhập để gửi bình luận"
                  : "Gửi bình luận"}
              </button>
            </form>
          </div>
        </div>
        <div className={`lg:col-span-1`}>
          {/* <div className={`sticky top-0 ${scrolled ? "pt-16" : "pt-0"}`}> */}
          <ButtonTitle title="Chuyên mục liên quan" />
          <div className="bg-base-100  rounded-lg shadow mb-4">
            <ul className="space-y-2 p-2">
              <li>Tin báo chí</li>
              <li>Tin hội viên</li>
              <li>Hoạt động</li>
              <li>Đại hội</li>
            </ul>
          </div>
          <ButtonTitle title="Tin tức & Sự kiện mới" />
          <div className="my-2">
            {posts
              ?.filter(
                (post) =>
                  post.status === "published" &&
                  post.slug !== "gioi-thieu" &&
                  post.slug !== "dieu-khoan"
              )
              ?.filter((post) => post.type !== "notification")
              ?.slice(0, 5)
              .map((post) => {
                return <ArticleCard key={post.id} article={post} />;
              })}
          </div>
          {/* </div> */}
        </div>
      </div>
      <ButtonTitle title="Hoạt động mới" />
      <Activiti />
      <ButtonTitle title="Đại hội" />
      <SocialResponsibility />
    </div>
  );
};

export default DetailPost;
